import { chakra } from '@chakra-ui/system';
import type { HTMLChakraProps } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';
import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';

import { useContainerStyles } from './';
import { getClassName } from './className';

export type ContainerBodyProps = PropsWithChildren<unknown> &
  HTMLChakraProps<'div'>;

export const ContainerBody = forwardRef<HTMLDivElement, ContainerBodyProps>(
  ({ children, className, ...props }, ref) => {
    const styles = useContainerStyles();

    return (
      <chakra.div
        ref={ref}
        __css={styles.containerBody}
        className={cx(getClassName('body'), className)}
        {...props}
      >
        {children}
      </chakra.div>
    );
  },
);
ContainerBody.displayName = 'ContainerBody';
